export const initialCommentStates = {
  streamId: '',
  timestamp: '',
  score: 0,
  orgId: '',
  commentId: '',
  content: '',
  metadata: {
    endorsersCount: 0,
    locked: false,
    bounty: 0,
    editedAt: '',
    replies: 0,
    pinned: false,
    createdAt: '',
    createdBy: '',
    private: false,
  },
  streamItemId: '',
  approved: false,
  channelId: '',
  bountyPurse: [],
  visibleTo: [],
  unlockPrice: null,
  userdata: {
    hasEndorsed: false,
    hasBookmarked: false,
    vote: null,
    tags: [],
  },
};
